import { map } from "rxjs/operators";
import { GET, POST } from "../../../module/services/fetch";
import config from "../../../utils/config";
import { of } from "rxjs";

//#region Technical User List
export interface ITechnicalUserListFilter
  extends Record<string, string | undefined> {
  orgUnit?: string;
  type?: string;
  code?: string;
  status?: string;
  description?: string;
}

export interface ITechnicalUser {
  code: string;
  description: string | null;
  type: string;
  organizationalUnit: string;
  ouCode: string;
  identitySystemId?: string;
}

interface ITechnicalUserListResponse {
  content: ITechnicalUser[];
  totalElements: number;
  pageTotalNumber: number;
  pageNumber: number;
  pageSize: number;
}

export const technicalUsersListService = (
  filters: ITechnicalUserListFilter,
  page: number = 1,
  size: number = 10
) => {
  const queryParam = new URLSearchParams(
    !filters
      ? undefined
      : Object.entries(filters).reduce((acc, [key, value]) => {
          if (value) {
            if (key === "type") {
              acc[key] = value === "robotuser" ? "Robot" : "Service";
            } else {
              acc[key] = value;
            }
          }
          return acc;
        }, {} as Record<string, string>)
  );
  queryParam.set("page", page.toString());
  queryParam.set("size", size.toString());

  return GET(`technical-users?${queryParam.toString()}`).pipe(
    map((response: ITechnicalUserListResponse) => {
      return {
        ...response,
        content: response.content
          .filter((user) => user.type === "Robot" || user.type === "Service")
          .map((user) => ({
            ...user,
            type: user.type === "Robot" ? "robotuser" : "serviceuser",
          })),
      };
    })
  );
};
//#endregion

//#region Technical User Detail

export interface ITechnicalUserDetailReponse extends ITechnicalUser {
  accounts: Array<{
    applicationName: string;
    id: number; // Account id
    applicationId: string;
    pwdcfg_name: string; // Application name
    identitySystemId: string;
    status: string;
    description: string;
    uigpOtpRequired: boolean;
    mfaRequired: boolean;
    securityQuestionsRequired: boolean;
    resetPasswordAllowed: boolean;
    changePasswordAllowed: boolean;
    actions: {
      unlockAccount: boolean;
      lockAccount: boolean;
    };
  }>;
}

export const technicalUserByCode = (code: string) => {
  // INTEGRATION
  if (config.apiAddress === "intapi.nexi.it") {
    return {
      accounts: [
        {
          attr2: "000000",
          code: "RR10006",
          forceChangePwd: 0,
          id: "528631",
          identitySystemId: "2",
          isDefault: 1,
          lastChangePwd: 1746628620000,
          meta: { lastModified: 1746628620000 },
          numberLoginError: 0,
          person_code: "RR10006",
          person_id: 145298,
          person_name: "Robot",
          person_surname: "User",
          persontype_id: 5113,
          persontype_name: "Robot",
          pwdcfg_id: 1,
          pwdcfg_name: "Ideas",
          pwdcfg_sync: 0,
          state: 0,
          status: "ACTIVE",
        },
      ],
    };
  }
  // STAGING OR PRODUCTION
  return GET(`technical-users/userCode/${code}`).pipe(
    map((response: ITechnicalUserDetailReponse) => response)
  );
};
//#endregion

//#region Technical User Types
interface ITechnicalUserType {
  usertypes: Array<"robotuser" | "serviceuser">;
}

export const technicalGetUserType = () => {
  // INTEGRATION
  if (config.apiAddress === "intapi.nexi.it") {
    return of(["robotuser", "serviceuser"]);
  }
  // STAGING OR PRODUCTION
  return GET("technical-users/usertype").pipe(
    map((response: ITechnicalUserType) => response.usertypes)
  );
};
//#endregion

//#region Technical User Robot Accounts
interface IRobotAccount {
  robotAccounts: Array<{
    id: number;
    name: string;
  }>;
}
export const technicalGetRobotAccounts = () => {
  return GET("technical-users/robotaccountlist").pipe(
    map((response: IRobotAccount) => response.robotAccounts)
  );
};
//#endregion

//#region Technical User Create
interface BaseTechnicalUserCreation {
  ouCode: string;
  notes: string;
  usertype: string;
  description: string;
}
interface ITechnicalUserRobotAccount extends BaseTechnicalUserCreation {
  accountIds: string[];
}
interface ITechnicalUserServiceAccount extends BaseTechnicalUserCreation {
  applicationId: string;
  entitlementIds: string[];
}

export const saveTechnicalUser = (obj: FormData) => {
  return POST(
    "technical-users/createTU/",
    obj,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  );
};

//#endregion

//#region Technical User Robot Accounts
interface OuModel {
  ou: string;
  identitySystemId?: string | null;
  name: string;
  description: string;
  ownercode?: string | null;
  code: string;
}

export const getOuList = () => {
  return GET("technical-users/ous").pipe(
    map((response: OuModel[]) => response)
  );
};
//#endregion
